import React, { Component } from 'react';
import {
  Modal,
  Select,
  Button,
  Dropdown,
  Spin,
  Col,
  Input,
  Switch,
  Strong,
  Form,
  Typography,
  Checkbox,
} from 'antd';
import {
  addNewVaccine,
  birthCriteria,
} from '../../services/api/cashless-vaccination';
const { Option } = Select;

class AddNewVaccination extends Component {
  constructor(props) {
    super(props);
    console.log(props, '[prop]');
    this.state = {
      name: '',
      isChild: null,
      ageLimitDetails: [],
      criteriaTextId: null,
      gender: null,
      baseVaccinePrice: null,
      loading: false,
    };
  }

  // addVaccination = () => {
  //   const body = {
  //     vaccineName: this.state.name,
  //     categoryId: this.props.vaccinationId,
  //   };
  //   if (body) {
  //     return addNewVaccine(body)
  //       .then((response) => {
  //         console.log(response, '[response]');
  //         if (response.body.message === 'success') {
  //           this.props.handleClose();
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err, 'err');
  //       });
  //   }
  // };

  getChildrenAgeDisclaimers = () => {
    return birthCriteria().then((response) => {
      if (response.body.message === 'success') {
        this.setState({
          ageLimitDetails: response.body.data,
        });
      }
    });
  };

  handleCriteriaChange = (event) => {
    this.setState(
      {
        isChild: event,
      },
      () => {
        if (this.state.isChild) {
          this.getChildrenAgeDisclaimers();
        }
      }
    );
  };

  render() {
    return (
      <Modal
        visible={this.props.modalIsOpen}
        title={this.props.title}
        onCancel={() => {
          this.props.handleClose();
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              this.props.handleClose();
            }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={this.state.loading}
            onClick={() =>
              this.props.submitApi(
                this.state.name,
                this.props.vaccinationId,
                this.state.isChild,
                this.state.criteriaTextId,
                this.state.gender,
                this.state.baseVaccinePrice
              )
            }
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          autoComplete="off"
        >
          <Form.Item label={this.props.label} name="vaccineCategory">
            <Input
              style={{
                width: '50%',
                marginLeft: '10px',
                marginRight: '10px',
              }}
              onChange={(event) => {
                this.setState({
                  name: event.target.value,
                });
              }}
            />
          </Form.Item>
          {this.props.addNewVaccine && (
            <Form.Item label="Age Birth Criteria" name="age">
              <Select
                style={{
                  width: '50%',
                  marginLeft: '10px',
                  marginRight: '10px',
                }}
                onChange={this.handleCriteriaChange}
                value={this.state.isChild}
              >
                <Option value={null}>Select an option</Option>
                <Option value={true}>Child</Option>
                <Option value={false}>Adult</Option>
              </Select>
            </Form.Item>
          )}
          {this.state.isChild && (
            <Form.Item label="Birth Criteria">
              <Select
                showSearch
                style={{ width: '50%', marginLeft: '10px' }}
                dropdownMatchSelectWidth={false}
                notFoundContent={
                  this.state.ageLimitDetails ? <Spin size="small" /> : null
                }
                placeholder="Search Category"
                defaultActiveFirstOption={true}
                filterOption={false}
                showArrow={false}
                // onSearch={this.searchCategory}
                // value={categoryName}
                onSelect={(value) => {
                  console.log({ value }, '[value]');
                  this.setState({ criteriaTextId: value });
                }}
              >
                {this.state.ageLimitDetails.map((ele) => (
                  <Select.Option key={ele.id}>
                    <Col>{ele.ageTitle}</Col>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {this.props.addNewVaccine && (
            <Form.Item label="Gender">
              <Select
                style={{ width: '50%', marginLeft: '10px' }}
                placeholder="Select Gender"
                onChange={(value) => {
                  this.setState({ gender: value });
                }}
              >
                <Option value="Male">Male</Option>
                <Option value="Fenale">Female</Option>
                <Option value="Both">Both</Option>
              </Select>
            </Form.Item>
          )}
          {this.props.addNewVaccine && (
            <Form.Item label="Base Price(MRP)">
              <Input
                style={{ width: '50%', marginLeft: '10px' }}
                placeholder="vaccine cost"
                onChange={(e) => {
                  this.setState({ baseVaccinePrice: e.target.value });
                }}
              />
            </Form.Item>
          )}
        </Form>
      </Modal>
    );
  }
}

export default AddNewVaccination;
